/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Checkbox } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [childCheckboxes, setChildCheckboxes] = useState({
    childOne: false,
    childTwo: false,
    childThree: true,
  });

  const handleParentCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;

    // Update child checkboxes based on parent checkbox state.
    setChildCheckboxes({
      childOne: isChecked,
      childTwo: isChecked,
      childThree: isChecked,
    });
  };

  const handleChildCheckboxChange = (
    childKey: keyof typeof childCheckboxes,
  ) => {
    // Set currently clicked child checkbox.
    setChildCheckboxes((prevState) => ({
      ...prevState,
      [childKey]: !prevState[childKey],
    }));
  };

  const isParentChecked = Object.values(childCheckboxes).every(
    (isChildChecked) => isChildChecked,
  );

  const isParentIndeterminate =
    Object.values(childCheckboxes).some((isChildChecked) => isChildChecked) &&
    !isParentChecked;

  return (
    <div className="n-flex n-flex-col n-items-start n-gap-1">
      <Checkbox
        isChecked={isParentChecked}
        isIndeterminate={isParentIndeterminate}
        label="Parent checkbox"
        onChange={(event) => {
          handleParentCheckboxChange(event);
        }}
      />
      <Checkbox
        className="n-ml-7"
        isChecked={childCheckboxes.childOne}
        label="Child checkbox 1"
        onChange={() => handleChildCheckboxChange('childOne')}
      />
      <Checkbox
        className="n-ml-7"
        isChecked={childCheckboxes.childTwo}
        label="Child checkbox 2"
        onChange={() => handleChildCheckboxChange('childTwo')}
      />
      <Checkbox
        className="n-ml-7"
        isChecked={childCheckboxes.childThree}
        label="Child checkbox 3"
        onChange={() => handleChildCheckboxChange('childThree')}
      />
    </div>
  );
};

export default Component;
